import cx from 'clsx';
import React from 'react';

import { ReactComponent as DeleteIcon } from '@assets/svg/chip-delete-icon.svg';

import style from './style.module.scss';

const ChipItem = ({ name, handleDelete, disabled, hidden }) => {
  return (
    <div
      className={cx(style.chipItem, { [style.chipItemDisabled]: disabled, [style.chipItemHidden]: hidden })}
    >
      <div className={style.chipItemName}>{name}</div>
      <DeleteIcon className={style.chipItemDeleteIcon} onClick={handleDelete} />
    </div>
  );
};

export default ChipItem;
